import React from "react";
import './nav.scss';
import { NavLink } from "react-router-dom";
import { Link } from "react-scroll";

export default function Navbar(){

    return (
      
     <div className="nav-bar home"> 
     <span>Jagadeeswaran</span>
     <ul>
      
    <li  className="hover-underline-animation">
          <Link to="home" smooth={true} duration={300}>
            Home
          </Link>
        </li>
        <li  className="hover-underline-animation">
          <Link to="about" smooth={true} duration={300}>
            About
          </Link>
        </li>
        <li  className="hover-underline-animation">
          <Link to="skills" smooth={true} duration={300}>
            Skills
          </Link>
        </li>
        <li  className="hover-underline-animation">
          <Link to="contact" smooth={true} duration={300}>
            Contact
          </Link>
        </li>
     </ul>
     
     </div>
    );
  }
  
 
